// extracted by mini-css-extract-plugin
export var darkMode = "_19-0";